import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useRef } from "react";
import { qoPartPractices } from "../../utils/queryOptions";
import { PracticesContextProvider } from "../../contexts/PracticesContextProvider";
import { UnitContext } from "../../contexts/contextExporter";
import PracticeMain from "./PracticeMain";
import LoadingScreen from "../../components/LoadingScreen";

export default function PracticeLoader({ partId }: { partId: number }) {
  const { next } = useContext(UnitContext);
  const { data: practices, isSuccess: fetchPracticeSuccess, isLoading } = useQuery(
    qoPartPractices({
      part_id: partId,
    })
  );

  // Bu part'ın hiç uygulaması yoksa (ör. sadece anlatım/demo videosu olan
  // bölümler) Uygulama ekranında takılmadan otomatik olarak bir sonraki
  // bölüme geç. partId başına yalnız bir kez tetiklenir.
  const isEmpty = fetchPracticeSuccess && (!practices || practices.length === 0);
  const advancedForPart = useRef<number | null>(null);
  useEffect(() => {
    if (isEmpty && advancedForPart.current !== partId) {
      advancedForPart.current = partId;
      next();
    }
  }, [isEmpty, partId, next]);

  if (isLoading) {
    return <LoadingScreen text="Sorular yükleniyor..." />;
  }

  return fetchPracticeSuccess ? (
    <PracticesContextProvider practices={practices} onComplete={next}>
      <PracticeMain />
    </PracticesContextProvider>
  ) : (
    <div className="flex items-center justify-center flex-1">
      <div className="bg-surface-1 border border-white/[0.08] rounded-2xl max-w-sm px-8 py-6 text-center">
        <p className="text-sm text-white/40">Bu bölümde soru yok, diğer bölüme geçene kadar lütfen bekle.</p>
      </div>
    </div>
  );
}
